<div class="container-fluid">
  <!--<div *ngIf="isLoading" class="page-spinner-overlay">
    <div class="spinner-content">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
      <div>Loading...</div>
    </div>
  </div>-->
  <div class="card">
    <div class="card-header nocollapse">
      Manage survey informational section
    </div>
    <div class="page-attributes p-1">
      <button class="btn btn-primary btn-action"
              (click)="openAddSectionModal(sectionModal)">
        <i class="fa fa-plus"></i> Create New Section
      </button>
    </div>
    <div class="card-header nocollapse bg-info col-md-12 msg-container" *ngIf="successOrFailureMessage!==''">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <b>{{successOrFailureMessage}}</b>
    </div>
  
    <isg-grid [rowData]="sectionnewlist"
              [columnDefs]="columnDefs"
              [config]="gridConfig"
              (gridReady)="onGridReady($event)">
    </isg-grid>

    <!--Section Modal-->
    <ng-template #sectionModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Section</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="sectionForm">
          <!--<div class="pull-right mb-2"><span class="text-danger">*</span> <span>Required field</span></div>-->
          <div class="mb-3 form-group row">
            <label for="sectionName" class="form-control-label col-md-2">Section Name <span class="text-danger">*</span></label>
            <input type="text" maxlength="31" id="sectionName" name="sectionName" formControlName="sectionName" class="form-control-sm col-md-8" />
            <small class="text-danger"
                   *ngIf="sectionForm.get('sectionName')?.invalid && sectionForm.get('sectionName')?.touched">
              Section Name is required
            </small>
          </div>
          <div class="mb-3 form-group">
            <kendo-editor formControlName="sectionDescription"
                          [resizable]="true"
                          [style.height.px]="250">
            </kendo-editor>
            <!--[value]="sectionForm.get('sectionDescription')?.value"-->
            <small class="text-danger"
                   *ngIf="sectionForm.get('sectionDescription')?.invalid && sectionForm.get('sectionDescription')?.touched">
              Section Description is required
            </small>
          </div>

          <!--<div class="mb-3 ck-editor__editable">
            <ckeditor name="sectionDescription" [config]="CkeditorConfig" formControlName="sectionDescription" skin="moono-lisa" language="en"></ckeditor>
          </div>-->
          <div class="form-check mb-3">
            <input type="checkbox" id="confirmation" name="confirmation" formControlName="confirmation" class="form-check-input" (change)="change($event)" />
            <label class="form-check-label" for="confirmation">Confirmation Required</label>
          </div>
          <!--<div class="" [hidden]="!isAgreeDisagreedisabled">
            <div class="radio pl-3">
              <input type="radio" id="isAgree" name="isAgree" formControlName="isAgree" class="form-control-sm" /><span class="form-control-label col-md-2">
                <input type="text" id="AcceptedText" name="AcceptedText" formControlName="AcceptedText" class="form-control-sm col-md-4" />
              </span> <br />
              <input type="radio" id="isDisagree" name="isDisagree" formControlName="isDisagree" class="form-control-sm" /><span class="form-control-label col-md-2"> <input type="text" id="NotAcceptedText" name="NotAcceptedText" formControlName="NotAcceptedText" class="form-control-sm col-md-4" /></span>
            </div>
          </div>-->
          <div [hidden]="!isAgreeDisagreedisabled">
            <div class="form-group row align-items-center mb-2">
              <div class="col-md-1 text-end">
                <input type="radio"
                       id="isAgree"
                       name="agreement"
                       [checked]="sectionForm.get('isAgree')?.value === true"
                       (click)="toggleRadio('isAgree')"
                       class="form-check-input" />
              </div>
              <div class="col-md-5">
                <input type="text"
                       id="AcceptedText"
                       name="AcceptedText"
                       formControlName="AcceptedText"
                       class="form-control form-control-sm"
                       placeholder="Accepted Text" />
              </div>
            </div>
            <div class="form-group row align-items-center">
              <div class="col-md-1 text-end">
                <input type="radio"
                       id="isDisagree"
                       name="agreement"
                       [checked]="sectionForm.get('isAgree')?.value === false"
                       (click)="toggleRadio('isDisagree')"
                       class="form-check-input" />
              </div>
              <div class="col-md-5">
                <input type="text"
                       id="NotAcceptedText"
                       name="NotAcceptedText"
                       formControlName="NotAcceptedText"
                       class="form-control form-control-sm"
                       placeholder="Not Accepted Text" />
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss(); onClose()">
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-primary btn-modal" [disabled]="sectionForm.invalid" (click)="saveSection()">
          <i class="fa fa-save"></i> Save
        </button>
      </div>
    </ng-template>

    <!--Delete Confirmation Modal-->
    <ng-template #deleteSectionModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Delete Section Confirmation</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to delete this informational section?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()">
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-danger btn-modal" (click)="modal.close(); deleteSection()">
          <i class="fa fa-trash"></i> Delete
        </button>
      </div>
    </ng-template>
  </div>
</div>
